import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=ffede72e&"
import script from "./CommonTable.vue?vue&type=script&lang=js&"
export * from "./CommonTable.vue?vue&type=script&lang=js&"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=ffede72e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QTd,QPagination,QSpinner});
